import React from 'react';
import { CreditCard, Wallet, Link as LinkIcon, CheckCircle2, ShieldCheck, ArrowRight } from 'lucide-react';
import './MercadoPago.css';

const MercadoPago = () => {
  return (
    <div className="mercadopago-page">
      <div className="page-header">
        <div className="title-section">
          <h1>Cobros por Mercado Pago</h1>
          <p>Integra tu cuenta y empieza a recibir pagos de tus pacientes de forma automática y segura.</p>
        </div>
        <div className="header-status">
          <span className="status-indicator active"></span>
          <span className="status-text">SERVICIO ACTIVO</span>
        </div>
      </div>

      <div className="mp-grid">
        <div className="mp-main card animate-fade">
          <div className="card-header-icon">
            <Wallet size={32} color="var(--primary-cyan)" />
          </div>
          <h2>Tu Billetera GDT</h2>
          <div className="balance-display">
            <span className="balance-label">SALDO DISPONIBLE</span>
            <span className="balance-amount">$ 124.500,00</span>
          </div>
          <div className="mp-actions">
            <button className="btn-primary">RETIRAR DINERO</button>
            <button className="btn-secondary">VER MOVIMIENTOS</button>
          </div>
        </div>

        <div className="mp-config card animate-fade" style={{ animationDelay: '0.1s' }}>
          <h3>Configuración de Cuenta</h3>
          <div className="config-item">
            <div className="config-info">
              <span className="config-label">CUENTA VINCULADA</span>
              <span className="config-value">info@gestionamientodeturnos.com</span>
            </div>
            <span className="verified-badge"><CheckCircle2 size={14} /> VERIFICADA</span>
          </div>
          <div className="config-item">
            <div className="config-info">
              <span className="config-label">MÉTODO DE PAGO</span>
              <span className="config-value">Link de Pago / QR / Tarjetas</span>
            </div>
            <button className="btn-text">CAMBIAR</button>
          </div>
        </div>
      </div>

      <div className="mp-features-grid">
        <div className="feature-box card">
          <LinkIcon size={24} className="feat-icon" />
          <h4>Links de Pago</h4>
          <p>Envía links personalizados por WhatsApp al momento de asignar el turno.</p>
          <button className="btn-link">CONFIGURAR <ArrowRight size={14} /></button>
        </div>
        <div className="feature-box card">
          <ShieldCheck size={24} className="feat-icon" />
          <h4>Seguridad Fintech</h4>
          <p>Protección contra fraudes y encriptación de datos bancarios de nivel bancario.</p>
          <button className="btn-link">VER MÁS <ArrowRight size={14} /></button>
        </div>
        <div className="feature-box card">
          <CreditCard size={24} className="feat-icon" />
          <h4>Múltiples Medios</h4>
          <p>Acepta todas las tarjetas de crédito, débito y dinero en cuenta MP.</p>
          <button className="btn-link">COMISIONES <ArrowRight size={14} /></button>
        </div>
      </div>
    </div>
  );
};

export default MercadoPago;
